import React from 'react'
import type { Icon } from 'shared/utils'

const CircleBacon = (props: Icon) => {
    const {
        color = 'white',
        background = '#A11A2C',
        size = 32,
        className = 'circle-bacon'
    } = props
    return (
        <svg width={size} height={size} className={className}>
            <g fill="none" fillRule="evenodd">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={size / 2}
                    fill={background}
                />
                <path
                    fill={color}
                    d="M22.42 15.581c-.986-.22-2.082-.467-3.561.296-1.48.764-1.894 1.832-2.266 2.762-.359.891-.698 1.735-1.927 2.383-1.23.648-2.12.448-3.058.241a6.872 6.872 0 0 0-1.542-.22 4.101 4.101 0 0 0-1.634.345l-.69-1.968c1.092-.482 1.914-.3 2.78-.104.978.22 2.084.468 3.551-.304 1.467-.77 1.892-1.824 2.268-2.754.359-.891.698-1.735 1.927-2.383 1.23-.648 2.12-.448 3.058-.24.892.2 1.892.42 3.176-.126l.69 1.97c-1.092.48-1.912.295-2.779.102h.007zm3.561-.038l-1.855-5.302a.361.361 0 0 0-.508-.2c-1.234.649-2.12.449-3.058.241-.976-.219-2.085-.467-3.554.304-1.47.771-1.892 1.824-2.268 2.754-.359.892-.699 1.735-1.928 2.383-1.228.648-2.12.448-3.057.241-.981-.231-2.09-.482-3.56.292a.362.362 0 0 0-.173.438l1.855 5.302a.362.362 0 0 0 .509.2c1.234-.649 2.12-.449 3.058-.241.976.219 2.084.467 3.551-.304 1.468-.771 1.894-1.824 2.268-2.754.359-.892.699-1.735 1.928-2.383 1.229-.649 2.12-.449 3.057-.241.976.219 2.085.467 3.555-.304a.361.361 0 0 0 .18-.426z"
                />
            </g>
        </svg>
    )
}

export { CircleBacon }
